import { request } from './core'
import type { ResearchResponse } from './types'

export const researchApi = {
  getResearch: (slug: string) =>
    request<ResearchResponse>(`/api/assessments/${slug}/research`),

  triggerResearch: (slug: string, revision?: number) =>
    request<{ status: string; revision?: number }>(
      `/api/assessments/${slug}/research`,
      { method: 'POST' },
      { ifMatch: revision },
    ),

  acceptFinding: (slug: string, fieldPath: string, revision?: number) =>
    request<{ ok: boolean; revision?: number }>(
      `/api/assessments/${slug}/research/findings/${encodeURI(fieldPath)}/accept`,
      { method: 'POST' },
      { ifMatch: revision },
    ),

  /** Accept ALL pending findings in one atomic request (replaces a per-finding
   *  loop that was slow + timeout-prone for large finding sets). */
  acceptAllFindings: (slug: string, revision?: number) =>
    request<{ ok: boolean; applied: string[]; remaining: number; revision?: number }>(
      `/api/assessments/${slug}/research/findings/accept-all`,
      { method: 'POST' },
      { ifMatch: revision },
    ),

  rejectFinding: (slug: string, fieldPath: string, revision?: number) =>
    request<{ ok: boolean; revision?: number }>(
      `/api/assessments/${slug}/research/findings/${encodeURI(fieldPath)}/reject`,
      { method: 'POST' },
      { ifMatch: revision },
    ),
}
